"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _SVGIcon = _interopRequireDefault(require("./SVGIcon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function createSVGIcon(path, displayName) {
  var viewBox = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '0 0 217 217';

  var Icon = function Icon(props) {
    return /*#__PURE__*/_react["default"].createElement(_SVGIcon["default"], _extends({
      viewBox: viewBox,
      title: displayName
    }, props), path);
  };

  Icon.displayName = "".concat(displayName, "Icon");
  return /*#__PURE__*/_react["default"].memo(Icon);
}

var _default = createSVGIcon;
exports["default"] = _default;